import React, { memo, useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
const CardMeta = function CardMeta(props) {
    const { prefixCls: customizePrefixCls, className, avatar, title, description, ...others } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const classString = classNames(`${prefixCls}-meta`, className);
    const avatarDom = avatar ? React.createElement("div", { className: `${prefixCls}-meta-avatar` }, avatar) : null;
    const titleDom = title ? React.createElement("div", { className: `${prefixCls}-meta-title` }, title) : null;
    const descriptionDom = description ?
        React.createElement("div", { className: `${prefixCls}-meta-description` }, description) : null;
    const MetaDetail = titleDom || descriptionDom ?
        React.createElement("div", { className: `${prefixCls}-meta-detail` },
            titleDom,
            descriptionDom) : null;
    return (React.createElement("div", Object.assign({}, others, { className: classString }),
        avatarDom,
        MetaDetail));
};
CardMeta.displayName = 'CardMeta';
export default memo(CardMeta);
